// Cubitt: botones − y + de la cantidad en el carrito lateral. Cambian el campo de cantidad y lanzan su "change", así
// line-item-quantity actualiza el carrito por la vía de siempre (/cart/change.js), con los mismos eventos para las apps.
// Solo una vez: el carrito lateral se repinta con createContextualFragment (theme.js, CartDrawer) y eso vuelve a
// ejecutar este <script>; sin la guarda quedaban dos listeners y un clic en + sumaba 2 (dos /cart/change.js).
if (!window.cubittCartStepper) {
  window.cubittCartStepper = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cubitt-qty-step]');
    if (!button || button.disabled) return;
    const input = button.parentElement.querySelector('input[data-line-key]');
    if (!input) return;
    const current = parseInt(input.value, 10) || 0;
    const max = input.max ? parseInt(input.max, 10) : Infinity;
    const next = Math.max(0, Math.min(max, current + parseInt(button.dataset.cubittQtyStep, 10)));
    if (next === current) return;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
}
